import { StockDataSourceService } from 'src/app/core/data-sources/stock-data-source.service';
import { SnackBarService } from './../../../core/services/snack-bar.service';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { GroupPosition, Level, Pallet } from '../stock-levels-modal.component';
import { GroundType } from 'src/app/pages/map/warehouse-map-task-position-view/ground-cell';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmModalComponent } from '../../confirm-modal/confirm-modal.component';
import { ActionService } from 'src/app/core/services/action.service';
import { ActionsEnum } from 'src/app/core/data-sources/action-data-source.service';
import { ErrorsEnum, ErrorService } from 'src/app/core/services/error.service';
import { setOccupationChartDataset } from 'src/app/helpers/chart-helper';
import { GroundGroupPosition } from 'src/app/core/data-sources/ground-position-group-data-source.service';
import { TenantInterface } from 'src/models/Tenant';
import { TenantService } from 'src/app/core/services/tenant.service';
import { UserRoles } from 'src/models/User';
import { ActivatedRoute } from '@angular/router';
import { V3GroundPositionGroupsDataSourceService } from 'src/app/core/data-sources/v3/ground-position-groups/ground-position-groups-data-source.service';

@Component({
  selector: 'app-position-details',
  templateUrl: './position-details.component.html',
  styleUrls: ['./position-details.component.scss']
})
export class PositionDetailsComponent implements OnChanges, OnInit {
  @Output() closeStockLevelsModal = new EventEmitter<boolean>();
  @Output() changeToEditLevel = new EventEmitter();
  @Output() onInventoryClick = new EventEmitter<boolean>();
  @Input() group: GroupPosition = {
    id: '',
    name: '',
    type: '',
    levelsEnabled: false
  };
  @Input() position: GroundGroupPosition;
  @Input() occupationList = [];
  @Input() levels: Level[] = [];
  @Input() pallets: Pallet[];
  @ViewChild('notification', { static: true }) notificationTmpl;
  groundTypes = GroundType;
  notificationData: { type: string; title: string; message: string; };
  datasets = [{
    data: [10, 10],
    backgroundColor: ['#92B531', '#E8EBEF']
  }];
  chartLabels = ['Posições Ocupadas', 'Posições Livres'];
  tooltipMessage: string | null = null;
  tenant: TenantInterface;
  userRole: UserRoles = null;
  editLevelsTooltipMsg = "Apenas usuários Master podem editar o nível da posição."

  constructor(
    private dialog: MatDialog,
    private actionService: ActionService,
    private errorService: ErrorService,
    private snackBarService: SnackBarService,
    private stockDataSourceService: StockDataSourceService,
    private tenantService: TenantService,
    private route: ActivatedRoute,
    private v3GroundPositionGroupsService: V3GroundPositionGroupsDataSourceService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.occupationList.length) this.datasets[0].data = setOccupationChartDataset(this.occupationList);
    this.tooltipMessage = this.group.id ? null : 'Posições sem grupo não podem ser inventariadas. Atribua a posição a um grupo e tente novamente.';
    if (changes.levels?.currentValue) this.getLevelGroupName(this.levels);
  }

  async ngOnInit() {
    this.tenant = await this.tenantService.get();
    this.userRole = this.route.snapshot.firstChild.data.role;
  }

  removePallets() {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      panelClass: 'confirm-modal',
      autoFocus: false,
      data: {
        label: `Você tem certeza que deseja remover o(s) ${this.pallets.length} pallet(s) da posição ${this.position.coords}?`,
        confirmBtnClass: 'alert'
      }
    });

    dialogRef.afterClosed().subscribe(async (res) => {
      if (res) {
        const rfids: string[] = [];
        rfids.push(this.position.rfid);
        try {
          await this.actionService.removePalletsFromExitPosition({
            type: ActionsEnum.EXIT_BY_GROUND_POSITION,
            data: {
              rfids: rfids
            }
          });
          this.notificationData = {
            type: 'success',
            title: 'Pallet(s) removido(s) com sucesso!',
            message: `O(s) ${this.pallets.length} pallet(s) da posição ${this.position.coords} foram removidos com sucesso.`
          };
          //TODO: refatorar esse sistema de notificação
          const notificationId = '99';
          this.snackBarService.showFeedback(this.notificationTmpl, this.notificationData, notificationId);
          setTimeout(() => {
            this.snackBarService.hideNotification(notificationId);
          }, 5000);
          this.stockDataSourceService.reloadMap$.next(true);
          this.closeStockLevelsModal.emit(true);
        } catch (err) {
          if (err.error.type === "GROUND_POSITION_TYPE_INVALID") {
            const message = `A posição escolhida não é uma posição de Saída`;
            this.errorService.openErrorSnackBarWithCustomMessage(message);
            return;
          }
          this.errorService.openErrorSnackBar(err);
        }
      }
    });
  }

  deletePosition() {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      panelClass: 'confirm-modal',
      autoFocus: false,
      data: {
        label: `Você tem certeza que deseja excluir a posição ${this.position.coords}?\nEsta ação não pode ser desfeita.`,
        confirmBtnClass: 'alert'
      }
    });
    dialogRef.afterClosed().subscribe(async (res) => {
      if (res) {
        try {
          await this.actionService.deletePosition({ rfid: this.position.rfid });
          this.notificationData = {
            type: 'success',
            title: 'Posição excluída com sucesso!',
            message: `A posição ${this.position.coords} foi excluída com sucesso.`
          };
          const notificationId = '100';
          this.snackBarService.showFeedback(this.notificationTmpl, this.notificationData, notificationId);
          setTimeout(() => {
            this.snackBarService.hideNotification(notificationId);
          }, 5000);
          this.stockDataSourceService.reloadMap$.next(true);
          this.closeStockLevelsModal.emit(true);
        } catch (err) {
          const error = err?.error?.body;
          if (!error || !error.type) return;

          switch (error.type) {
            case ErrorsEnum.FORBIDDEN_ACTION_FOR_USER_TYPE:
              this.errorService.openErrorSnackBarWithCustomMessage(`Funcionalidade permitida apenas para usuários Master.`);
              break;
            case ErrorsEnum.GROUND_POSITION_WITH_TASK:
              this.errorService.openErrorSnackBarWithCustomMessage(`Não é permitido excluir posições que tenham tarefas relacionadas. Complete ou remova as tarefas e tente novamente.`);
              break;
            case ErrorsEnum.GROUND_POSITION_WITH_PALLET:
              this.errorService.openErrorSnackBarWithCustomMessage(`Não é permitido excluir posições ocupadas por paletes. Esvazie a posição e tente novamente.`);
              break;
          }
        }
      }
    });
  }

  inventory(position) {
    this.onInventoryClick.emit(position);
  }

  editLevel(level: Level, position) {
    this.changeToEditLevel.emit({ level: level, position: position });
  }

  canEditLevels() {
    return [UserRoles.MASTER].includes(this.userRole);
  }

  isMasterUser() {
    return this.userRole === UserRoles.MASTER;
  }

  async getLevelGroupName(levels: Level[]) {
    if (!levels || !levels.length) return;

    const groups = await this.v3GroundPositionGroupsService.getAll().toPromise();

    for (const level of levels) {
      const groupId = level.groundPositionGroupId || null;
      const groupName = groupId
        ? (groups.find(g => g.id === groupId)?.name || 'Sem Grupo')
        : 'Sem Grupo';
      
      level.groupName = groupName;
    }
  }

}
